import * as React from 'react';
import { ITranslationsCollection, translate } from 'elc-service';
import { Breadcrumbs, IItem } from 'elc-breadcrumbs';
import { Row } from 'elc-grid';
import styled from 'styled-components';
import { Body2 } from 'elc-typography';
import { Breakpoints } from 'elc-base-theme';
import { Product } from '../../internal/domain/entities/Product';
import { Mobile, Desktop } from 'elc-layouts';
import { StyledAnchorTheme } from '../../theme/default-theme';

export interface IProductBreadcrumbs {
    product: Product;
    siteUrl?: string;
    translations?: ITranslationsCollection;
}

const StyledAnchor = styled.a`
    text-decoration: none;
`;

const AnchorText = styled(Body2)`
    display: inline-block;
    ${StyledAnchorTheme};
    &:hover {
        text-decoration: underline;
    }
    &::before {
        content: '<';
        padding-right: 3px;

        [dir='rtl'] & {
            padding-left: 3px;
            padding-right: 0;
        }
    }
`;

export const ProductBreadcrumbs = translate(['homeLabel'])((props: IProductBreadcrumbs) => {
    const translations = props.translations as ITranslationsCollection;
    const { product, siteUrl } = props;
    const { homeLabel } = translations;

    const homeBreadcrumbItem: IItem = {
        href: siteUrl,
        label: homeLabel
    };
    const defaultCategoryBreadcrumbItem: IItem = {
        href: product.defaultCategory.url,
        label: product.defaultCategory.value
    };
    const breadcrumbItems = [homeBreadcrumbItem, defaultCategoryBreadcrumbItem];
    const defaultCategoryItem = defaultCategoryBreadcrumbItem;

    return (
        <Row>
            <Desktop minWidth={Breakpoints.desktop}>
                {() => <Breadcrumbs links={breadcrumbItems} delimiter="/" />}
            </Desktop>
            <Mobile maxWidth={Breakpoints.desktop - 1}>
                {() => (
                    <StyledAnchor href={defaultCategoryItem.href} title={defaultCategoryItem.label}>
                        <AnchorText>{defaultCategoryItem.label}</AnchorText>
                    </StyledAnchor>
                )}
            </Mobile>
        </Row>
    );
});
